import script from "./DebtDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DebtDataForm.vue?vue&type=script&setup=true&lang=js"

import "./DebtDataForm.vue?vue&type=style&index=0&id=0ce931c9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce931c9"]])

export default __exports__